var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgColumn(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "xMidYMid meet",
    "data-bbox": "47.1 74 105.701 62.3",
    viewBox: "47.1 74 105.701 62.3",
    height: 200,
    width: 200,
    xmlns: "http://www.w3.org/2000/svg",
    "data-type": "color",
    role: "presentation",
    "aria-hidden": "true",
    "aria-label": "",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M119.1 92.2H80.9c-.5 6.4-4.5 11.8-10.1 14.3v29.8h7.9V112c0-2.4 1.9-4.3 4.3-4.3s4.3 1.9 4.3 4.3v24.2h8.4V112c0-2.4 1.9-4.3 4.3-4.3s4.3 1.9 4.3 4.3v24.2h8.7V112c0-2.4 1.9-4.3 4.3-4.3s4.3 1.9 4.3 4.3v24.2h7.9v-29.8c-5.9-2.3-9.9-7.8-10.4-14.2z",
    fill: "#F58220"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M137.2 74.1l-8-.1H64c-9.3 0-16.9 7.6-16.9 16.9 0 9.3 7.6 16.9 16.9 16.9 2.4 0 4.7-.5 6.7-1.4 5.6-2.4 9.7-7.9 10.1-14.3h38.3c.5 6.4 4.5 11.8 10.1 14.3 2.1.9 4.3 1.4 6.7 1.4 9.3 0 16.9-7.6 16.9-16.9.1-8.9-6.8-16.2-15.6-16.8zM64 97c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6zm72 0c-3.3 0-6-2.7-6-6s2.7-6 6-6 6 2.7 6 6-2.7 6-6 6z",
    fill: "#FEC178"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F58220",
    d: "M70 91a6 6 0 11-12 0 6 6 0 0112 0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#F58220",
    d: "M142 91a6 6 0 11-12 0 6 6 0 0112 0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M82.9 107.8c-2.4 0-4.3 1.9-4.3 4.3v24.2h8.6V112c0-2.3-1.9-4.2-4.3-4.2z",
    fill: "#FEC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M117.1 107.8c-2.4 0-4.3 1.9-4.3 4.3v24.2h8.6V112c0-2.3-1.9-4.2-4.3-4.2z",
    fill: "#FEC178"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M99.8 107.8c-2.4 0-4.3 1.9-4.3 4.3v24.2h8.6V112c0-2.3-1.9-4.2-4.3-4.2z",
    fill: "#FEC178"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgColumn);
export default __webpack_public_path__ + "static/media/column.380fef0a04d110df5f5a14f197698541.svg";
export { ForwardRef as ReactComponent };